module.exports = __webpack_public_path__ + "img/bonus_symbol_2.2a8e6de3.png";